export enum PaymentStatus {
  Loading,
  Success,
  Failure,
  FailedSubmitOrder,
}
